import classNames from 'classnames'
import { forwardRef, HTMLAttributes, ReactNode } from 'react'

import { BodyText } from '../body-text/body-text'
import styles from './file-label.module.scss'
import { useFile } from './use-file'

export type FileLabelElement = HTMLParagraphElement

export interface FileLabelProps extends HTMLAttributes<FileLabelElement> {
  children: ReactNode
}

const FileLabel = forwardRef<FileLabelElement, FileLabelProps>(function FileLabel(
  props,
  forwardedRef
) {
  const { className, children, ...rest } = props

  const { selected, error } = useFile()
  const classes = classNames(
    styles.root,
    {
      [styles.selected]: selected,
      [styles.error]: error,
    },
    className
  )

  return (
    <BodyText {...rest} className={classes} ref={forwardedRef} size="md" asChild>
      <p>{children}</p>
    </BodyText>
  )
})

export default FileLabel
